import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_disciplinary_measures_for_wrkrs_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'are_disciplinary_measures_for_wrkrs_in_line_w_legal_reqs',
  name: 'Are disciplinary measures for workers in line with legal requirements?',
  description:
    "Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nDisciplinary measures are typically actions taken as a result of a worker's performance or behavior.\r\r\n\r\r\nFor example, legal requirements may provide that only certain types of disciplinary measures are acceptable, or they may prohibit certain types of measures.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11550,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
